import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'login',
  template: `
    <p>
      login works!
    </p>
  `,
  styles: []
})
export class LoginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
